// Translation files
import ar from './ar.json';
import de from './de.json';
import en from './en.json';
import fr from './fr.json';
import tr from './tr.json';
import sq from './sq.json';
import bs from './bs.json';
import fa from './fa.json';
import prs from './prs.json';
import ta from './ta.json';
import ru from './ru.json';
import pl from './pl.json';
import ku from './ku.json';
import ur from './ur.json';

export const translations = {
  ar,
  de,
  en,
  fr,
  tr,
  sq,
  bs,
  fa,
  prs,
  ta,
  ru,
  pl,
  ku,
  ur
};

export const bundledLanguages = [
  { shortcut: 'ar', name: 'عربي' },
  { shortcut: 'de', name: 'Deutsch' },
  { shortcut: 'en', name: 'English' },
  { shortcut: 'fr', name: 'Français' },
  { shortcut: 'tr', name: 'Türkçe' },
  { shortcut: 'sq', name: 'Shqip' },
  { shortcut: 'bs', name: 'Bosanski' },
  { shortcut: 'fa', name: 'فارسی' },
  { shortcut: 'prs', name: 'دری' },
  { shortcut: 'ta', name: 'தமிழ்' },
  { shortcut: 'ru', name: 'Русский' },
  { shortcut: 'pl', name: 'Polski' },
  { shortcut: 'ku', name: 'Kurdî' },
  { shortcut: 'ur', name: 'اردو' }
];

export const defaultLanguage = 'en';

// Get browser language
export const getBrowserLanguage = () => {
  const browserLang = navigator.language || navigator.userLanguage;
  const langCode = browserLang.split('-')[0].toLowerCase();
  
  if (translations[langCode]) {
    return langCode;
  }

  const fullLang = browserLang.toLowerCase();
  const langMap = {
    ar: 'ar', de: 'de', en: 'en', fr: 'fr', tr: 'tr', sq: 'sq', bs: 'bs',
    fa: 'fa', prs: 'prs', ta: 'ta', ru: 'ru', pl: 'pl', ku: 'ku', ur: 'ur'
  };
  for (const [code, out] of Object.entries(langMap)) {
    if (fullLang.startsWith(code)) return out;
  }
  
  return defaultLanguage;
};



